<template>
  <div class="descriptionPage page">
    <div>
      <description @enter="enter" @goBack="goBack">
        <template v-slot:content>
          即将跳转前往保险提供公司页面，在使用此项业务之前，请务必仔细阅读以下内容：<br />
          1.如您实际使用本项业务，则表示您同意遵守《WoYou工资服务及免责说明》和《WoYou工资隐私政策》的所有条款；<br />
          2.
          WoYou工资平台与保险经纪公司达成特别合作，本平台仅为保险公司提供信息发布和链接跳转的技术服务，具体业务内容均由保险公司提供，业务所订立的合同与本平台全无关系。您应明悉保险提供公司的各项条款，明确本人的应尽义务，对于可能引发的任何纠纷或风险均由用户承担，平台概不承担或负责；<br />
          3.根据法律法规及规范性文件的规定，办理保险业务时可能需要您提供必要的企业信息如公司营业执照等，具体可向保险提供公司咨询；<br />
          4.微信支付（保险订单生效时间为T+1）及企业对公转账（保险订单生效时间为T+2）（保险公司要求）；<br />
          5.有关保险可能存在的时效性、地域性、管理周期等问题，如有疑问请向保险提供公司咨询。<br />
        </template>
      </description>
    </div>
  </div>
</template>

<script>
import description from "@/components/description";
import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  mixins: [verifyPermissionMinix],
  components: {
    description,
  },
  props: {
    bankInfoList: Array,
  },
  data() {
    return {
      checked: false,
    };
  },
  created() {},
  methods: {
    goBack() {
      this.$router.push({ path: "/insuranceList", query: { flag: 1 } });
    },

    enter() {
      this.$router.push({
        path: "/insuranceIntroduction",
        // query: { myObj: encodedObj },
      });
    },
  },
  watch: {},
};
</script>
<style lang="less">
.descriptionPage .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="less" scoped>
.descriptionPage {
  .title {
    text-align: center;
    font-size: 20px;
  }
  .content {
    padding: 20px 300px;
    line-height: 25px;
  }
  .btnBox {
    position: fixed;
    bottom: 60px;
    left: calc(50% - 82px);
    text-align: center;
    .btn {
      margin-top: 10px;
    }
  }
}
</style>